"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AutocompleteEditCellListbox = void 0;
const react_1 = __importDefault(require("react"));
const autocomplete_edit_cell_styles_1 = require("./autocomplete-edit-cell.styles");
const generic_1 = require("../../../generic");
exports.AutocompleteEditCellListbox = react_1.default.forwardRef((_a, ref) => {
    var { children, moreItemsLoading } = _a, props = __rest(_a, ["children", "moreItemsLoading"]);
    return (react_1.default.createElement(autocomplete_edit_cell_styles_1.StyledAutocompleteEditCellListbox, Object.assign({ ref: ref }, props), children, moreItemsLoading && react_1.default.createElement(generic_1.LoadingIndicator, { className: "load-more-indicator" })));
});
exports.AutocompleteEditCellListbox.displayName = 'AutocompleteEditCellListbox';
